import React from 'react';
import { observer } from 'mobx-react';
import { Drawer } from 'ksnm-common-ui/lib/Drawer';
import { FormWrapper } from 'ksnm-common-ui/lib/Form/FormWrapper';

import { passingControlStore } from '../../../../stores/passingControlStore';
import { Form } from './Form';

import styles from './AddControlVersionsDrawer.module.scss';

interface IAddControlVersionsDrawer {
  visible: boolean;
  onClose: () => void;
  organizationCode: string;
}

export const AddControlVersionsDrawer = observer(
  ({ visible, onClose, organizationCode }: IAddControlVersionsDrawer) => {
    const { addUncreatedReportsIntoPackage } = passingControlStore;

    const onSubmit = React.useCallback(
      async (values) => {
        addUncreatedReportsIntoPackage(
          {
            reportPackageCode: values.reportPackageCode,
            controlVersions: values.controlVersions,
          },
          organizationCode,
          onClose,
        );
      },
      [addUncreatedReportsIntoPackage, onClose, organizationCode],
    );

    return (
      <Drawer open={visible} onClose={onClose} title="Добавить КП в пакет">
        <FormWrapper
          onSubmit={onSubmit}
          layout="vertical"
          className={styles.form}
          initialValues={{ controlVersions: [] }}
        >
          <Form organizationCode={organizationCode} />
        </FormWrapper>
      </Drawer>
    );
  },
);
